import { Divider } from '@chakra-ui/react';
import { SideSubMenuItem } from '../SideSubMenuItem';
import { SideSubMenuGroup } from '../SideSubMenuGroup';
import { Wrapper } from './styles';
import { ReactElement } from 'react';
import { usePermition } from '@/hooks/usePermition';

interface Prop {
  items: Array<{
    title: string;
    to?: string;
    hasDivider?: boolean;
    childrens?: Array<{ title: string; to: string }>;
  }>;
  open: boolean;
}

export function SideSubMenu({ items, open }: Prop) {

  if (!items.length) return null;

  return (
    <Wrapper style={{ marginTop: '4px' }} className={open ? 'open' : ''}>
      {items.map((item, index) => {
        return (
          <div key={index}>
            {item?.hasDivider && <Divider />}
            {item.childrens && item.childrens.length > 0 ? (
              <SideSubMenuGroup title={item.title} childrens={item.childrens} />
            ) : (
              <SideSubMenuItem title={item.title} to={item.to ?? ''} />
            )}
          </div>
        );
      })}
    </Wrapper>
  );
}

export const SwapGetPermitionMenu = ({ children, item }: { children: ReactElement, item: any }) => {

  const { rotinas } = usePermition();

  const isAllowed = item?.id === 930 || rotinas?.some((r) => +r.id === item?.id);

  if (!isAllowed) return null;

  return children;
}